export default "__VITE_ASSET__PMPIVC0l__"